var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJobsProfileCompleteIcon = function SvgJobsProfileCompleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F2F4FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#JobsProfileCompleteIcon_svg__a)",
    fill: "#5C7AFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.394 10.683A2.675 2.675 0 0 1 16.06 8h3.88a2.675 2.675 0 0 1 2.666 2.683v.044c0 .422 0 .809-.042 1.124-.047.347-.156.713-.455 1.015-.3.301-.664.411-1.009.458-.313.042-.698.042-1.118.042H16.017c-.42 0-.805 0-1.118-.042-.344-.047-.709-.157-1.008-.458-.3-.302-.41-.668-.456-1.015-.042-.315-.042-.702-.041-1.124v-.044Zm2.666-1.22c-.67 0-1.212.546-1.212 1.22 0 .48.002.767.029.973a.695.695 0 0 0 .04.173l.002.002.002.001a.678.678 0 0 0 .172.041c.204.028.49.03.967.03h3.88c.477 0 .762-.002.966-.03a.68.68 0 0 0 .172-.04l.002-.002.002-.002a.684.684 0 0 0 .04-.173c.028-.206.03-.492.03-.973 0-.674-.543-1.22-1.213-1.22H16.06Zm-1.14 2.368h-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.121 9.951h-.056c-.396 0-.666 0-.903.032a3.647 3.647 0 0 0-3.13 3.15c-.032.238-.032.51-.032.908v7.427c0 1.334 0 2.41.113 3.256.117.878.368 1.617.952 2.204.584.588 1.319.84 2.192.958.84.114 1.91.114 3.235.114h3.016c1.326 0 2.395 0 3.236-.114.872-.118 1.607-.37 2.19-.958.585-.587.836-1.326.953-2.204.113-.846.113-1.922.113-3.256v-7.427c0-.399 0-.67-.031-.909a3.647 3.647 0 0 0-3.13-3.15c-.238-.031-.508-.03-.904-.03h-.056v1.463c.473 0 .64.001.77.018.979.13 1.749.905 1.878 1.89.017.13.018.298.018.775v7.317c0 1.4-.001 2.377-.1 3.114-.095.716-.27 1.095-.538 1.365-.269.27-.646.446-1.357.542-.733.1-1.704.1-3.096.1h-2.909c-1.392 0-2.362 0-3.095-.1-.711-.096-1.088-.272-1.357-.542-.268-.27-.443-.65-.538-1.365-.1-.737-.1-1.714-.1-3.114v-7.317c0-.477.001-.644.018-.775.129-.985.9-1.76 1.878-1.89.13-.017.297-.018.77-.018V9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.908 18.03a.735.735 0 0 0 0-1.035.724.724 0 0 0-1.028 0l-3.365 3.385-1.425-1.434a.724.724 0 0 0-1.028 0 .735.735 0 0 0 0 1.035l1.94 1.951a.724.724 0 0 0 1.028 0l3.878-3.902Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "JobsProfileCompleteIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 8)",
    d: "M0 0h16v20H0z"
  })))));
};

export default SvgJobsProfileCompleteIcon;